<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Avaliação Oficinas Reuniões Treinamentos"
            description="Avaliação e sugestões de temas em saúde digital"
            url="/oficinas-treinamentos"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-2371"
            pageIdentifier="avaliacao-treinamento"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw?.avaliacao_treinamento_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.avaliacao_treinamento_ajuda || 0
            "
            keyAjudaModalInformacao="avaliacao_treinamento_ajuda"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Avaliação Treinamentos',
    titleTemplate: null,
  },
}
</script>
